import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'flow-kpi-box-double',
  templateUrl: './kpi-box-double.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KpiBoxDoubleComponent { 
  @Input() groupTitle: string;
  @Input() title: string;
  @Input() firstSubTitle: string;
  @Input() secondSubTitle: string;
  @Input() firstValue: string | number;
  @Input() secondValue: string | number;
}
